import React, { useState, useRef, useEffect } from "react";
import { Menu } from "react-feather";
import savastiLogo from "../assests/cropped-Svasti mCRO Logo Final 2025 01 15-02.jpg";
import { Link, useNavigate } from "react-router-dom";
import Banner from "./Banner";
import notification_icon from "../assests/NavBar/notification-bell-svgrepo-com.svg";
import home_icon from "../assests/NavBar/icons8-home-50.png";
import logout_icon from "../assests/NavBar/7124045_logout_icon.png";
import soa_icon from '../assests/NavBar/soa.svg'
import StatementOfAccount from "./Statement/StatementOfAccount";
import { useLocation } from 'react-router-dom';
import LanguageSelector from "./LanguageSelector";

const Header = ({ customerInfo, labels, accountData, flag }) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const menuButtonRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const isSOAEndpoint = location.pathname === "/soa";

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                menuButtonRef.current &&
                !menuButtonRef.current.contains(event.target)
            ) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);


    return (
        <header className="w-full font-small sm:h-[24vh] md:h-[26vh] lg:h-[28vh] xl:h-[30vh] sticky top-0 font-gotham-rounded">
            <div
                className="relative flex items-center sm:h-[8vh] md:h-[10vh] lg:h-[11vh] xl:h-[11vh] px-5 py-1 sm:py-4 md:py-5 lg:py-6 xl:py-7"
                style={{ backgroundColor: "#fdba14" }}
            >
                {/* Menu button */}
                <div className="flex items-end h-16 justify-start">
                    <Menu ref={menuButtonRef} size="3rem" color="white" onClick={toggleMenu} />
                </div>

                {/* Logo, centered absolutely */}
                <div className="absolute left-1/2 transform -translate-x-1/2">
                    <Link to="/">
                        <img
                            src={savastiLogo}
                            alt="Savasti"
                            className="h-12 sm:h-16 md:h-10 lg:h-8 xl:h-8"
                        />
                    </Link>
                </div>
                <div className="absolute top-7 right-1">
                    <LanguageSelector />
                </div>
            </div>

            <div className="block lg:hidden flex item-center">
                {isMenuOpen && (
                    <div ref={menuRef} className="absolute right-4 h-[30vh] z-50 font-medium">
                        <div className="fixed w-full right-0 top-[3.6rem] pl-6 pt-2 pb-4 z-[-1] bg-[white] pl-[10px] pr-[10px]">
                            <div className="bg-[#FDBA14] rounded-lg font-bold">
                                <div>
                                    <Link to="/" className="w-[100%] h-[35px] border-b border-black-300 flex items-center gap-4 mx-auto px-[8%] py-[1%] border-b-2 font-poppinsMedium cursor-pointer">
                                        <img src={home_icon} alt="home_icon" className="w-6 h-6" />
                                        <div><p>{labels.home}</p></div>
                                    </Link>
                                </div>
                                <div>
                                    <Link to="/soa" className="w-[100%] h-[35px] border-b border-black-300 flex items-center gap-4 mx-auto px-[8%] py-[1%] border-b-2 font-poppinsMedium cursor-pointer">
                                        <img src={soa_icon} alt="home_icon" className="w-6 h-6" />
                                        <div><p>{labels.Soa}</p></div>
                                    </Link>
                                </div>
                                <div className="w-[100%] rounded-[4px] pt-[2%] bg-grey lg:hidden xs:block overflow-y-auto text-[15px]">
                                    <div className="w-[100%] h-[35px] border-b border-black-300 flex items-center gap-4 mx-auto px-[8%] py-[1%] border-b-2 font-poppinsMedium cursor-pointer">
                                        <img src={notification_icon} alt="notification_icon" className="w-6 h-6" />
                                        <div><p>{labels.notifications}</p></div>
                                    </div>
                                    <div onClick={() => {
                                        sessionStorage.clear();
                                        navigate("/login");
                                    }} className="w-[100%] h-[35px] border-b border-black-300 flex items-center gap-4 mx-auto px-[8%] py-[1%] border-b-2 font-poppinsMedium cursor-pointer">
                                        <img src={logout_icon} alt="logout_icon" className="w-6 h-6" />
                                        <div><p>{labels.logout}</p></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Banner labels={labels} customerInfo={customerInfo} />
            {isSOAEndpoint && accountData && flag && <StatementOfAccount Summary={accountData?.Summary} labels={labels} />}
        </header>
    );
}

export default Header;
